import { ProjectActions } from '@octopus-do/octopus-project-core'

import { InitialNodeIds } from '../nodes'
import { initialBlocks } from './initialBlocks'

export const InitBlocsAction = ProjectActions.blocks.add({
  index: 0,
  items: initialBlocks,
  parents: [InitialNodeIds.main.root],
})
